// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"538":"recorder","845":"alarmOverviewWorker","913":"rtgWorker","915":"apiWorker","983":"profiler"}[chunkId] || chunkId) + ".js";
};